const initialState = {};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'SERVER_CONTROL_TOOLS_SUCCESS') {
        return action.payload.reduce(
            (obj, item) => ({
                ...obj,
                [item.id]: item,
            }),
            {}
        );
    }

    if (
        (action.type === 'SERVER_CONTROL_TOOL_EXECUTE_SUCCESS' ||
            action.type === 'SERVER_CONTROL_TOOL_EXECUTE_FAILURE') &&
        action.payload
    ) {
        return {
            ...state,
            [action.actionParams.controlToolId]: {
                ...state[action.actionParams.controlToolId],
                response: {
                    arguments: action.requestParams.data.arguments,
                    code:
                        action.payload.exitStatus === 0
                            ? 0
                            : action.payload.exitStatus || action.payload.response?.data?.status,
                    message:
                        action.payload.out ||
                        action.payload.err ||
                        (action.payload.response?.data?.error &&
                            `${action.payload.response?.data?.error}: ${action.payload.response?.data?.message}`),
                },
            },
        };
    }

    return state;
}

export default reducer;
